import { Link } from 'react-router-dom';
import Mock from 'assets/images/mock.png';
import Like from 'assets/images/svg/like.svg';
import LikeGrey from 'assets/images/svg/like-grey.svg';
import { useAuthState } from 'context';

export const VotesCardBig = ({ news }) => {
	const { userDetails } = useAuthState();

	const image =
		news.images && news.images?.length > 0 ? news.images[0].path : Mock;

	return (
		<div className='news__item'>
			<Link to={`/voting/${news.id}`} className='new new_big'>
				<div className='new__img-block'>
					<img src={image} alt='' width='544' height='225'  />
				</div>
				<div className='new__text-block'>
					<p className='new__text'>{news.application.full_address}</p>
          <div className='votecard__text_wrap'>
            <span>Год <br/>постройки<b>{news.application.construction_year}</b></span>
            <span>Количество<br/>этажей <b>{news.application.flooring}</b></span>
            <span>Количество<br/>квартир <b>{news.application.apartments}</b></span>


          </div>
					<span className='new__date'>
						<img src={userDetails.voted_nominations?.includes(news.id) ? Like : LikeGrey} alt='' />
						{news.votes_count ? news.votes_count : 0}
					</span>
				</div>
			</Link>
		</div>
	);
};
